import type {
  FinishDefinition,
  PatternDefinition,
  SizeClass,
  WeightedOption,
} from "../../core/types";

export const genesisSizeWeights: readonly WeightedOption<SizeClass>[] = [
  { value: "small", weight: 0.7 },
  { value: "medium", weight: 0.24 },
  { value: "large", weight: 0.055 },
  { value: "colossal", weight: 0.005 },
];

export const genesisFormFamilies: readonly WeightedOption<string>[] = [
  { value: "Classic Smooth", weight: 1 },
];

export const genesisFinishFamilies: readonly WeightedOption<string>[] = [
  { value: "Island Porcelain", weight: 1 },
  { value: "Black Pearl", weight: 1 },
  { value: "Forged Gold", weight: 0.4 },
  { value: "Aged Bronze", weight: 0.6 },
  { value: "Sea Glass", weight: 0.8 },
  { value: "Polished Stone", weight: 0.8 },
];

export const genesis001PatternFamilies: readonly WeightedOption<string>[] = [
  { value: "Ghost Zebra", weight: 1 },
  { value: "Polka Tide", weight: 1 },
  { value: "Speckle Bloom", weight: 1 },
  { value: "Ripple Vein", weight: 1 },
  { value: "Marble Current", weight: 1 },
];

export const genesis002PatternFamilies: readonly WeightedOption<string>[] = [
  ...genesis001PatternFamilies,
  { value: "Mottle Drift", weight: 1 },
  { value: "Iridescent Bloom", weight: 1 },
];

export const genesisPatternFamilies = genesis002PatternFamilies;

export const genesisPaletteFamilies: readonly WeightedOption<string>[] = [
  { value: "Lilikoi Sunset", weight: 1 },
  { value: "Hanalei Rain", weight: 1 },
  { value: "Moonwater", weight: 1 },
  { value: "Deep Current", weight: 1 },
  { value: "Volcanic Dawn", weight: 1 },
];

export const genesisVentralStyle = "smooth-fold" as const;

export const genesisFinishDefinitions: Readonly<Record<string, FinishDefinition>> = {
  "Island Porcelain": {
    id: "island-porcelain", tint: [244, 238, 220], tintStrength: 0.38,
    detailTint: [0, 0, 0], desaturate: 0, roughness: { min: 0.12, max: 0.48 }, metalness: { min: 0, max: 0.06 },
  },
  "Black Pearl": {
    id: "black-pearl", tint: [29, 33, 43], tintStrength: 0.76,
    detailTint: [22, 24, 34], desaturate: 0, roughness: { min: 0.12, max: 0.48 }, metalness: { min: 0, max: 0.06 },
  },
  "Forged Gold": {
    id: "forged-gold", tint: [211, 160, 48], tintStrength: 0.7,
    detailTint: [0, 25, 0], desaturate: 0, roughness: { min: 0.16, max: 0.36 }, metalness: { min: 0.82, max: 0.98 },
  },
  "Aged Bronze": {
    id: "aged-bronze", tint: [95, 91, 48], tintStrength: 0.66,
    detailTint: [-15, 26, 0], desaturate: 0, roughness: { min: 0.16, max: 0.36 }, metalness: { min: 0.82, max: 0.98 },
  },
  "Sea Glass": {
    id: "sea-glass", tint: [122, 185, 177], tintStrength: 0.52,
    detailTint: [0, 0, 0], desaturate: 0, roughness: { min: 0.2, max: 0.42 }, metalness: { min: 0, max: 0.06 },
  },
  "Polished Stone": {
    id: "polished-stone", tint: [128, 128, 128], tintStrength: 0,
    detailTint: [0, 0, 0], desaturate: 0.58, roughness: { min: 0.12, max: 0.48 }, metalness: { min: 0, max: 0.06 },
  },
};

export const genesisPatternDefinitions: Readonly<Record<string, PatternDefinition>> = {
  "Ghost Zebra": { id: "ghost-zebra", algorithm: "zebra" },
  "Polka Tide": { id: "polka-tide", algorithm: "dots" },
  "Speckle Bloom": { id: "speckle-bloom", algorithm: "speckles" },
  "Ripple Vein": { id: "ripple-vein", algorithm: "ripples" },
  "Marble Current": { id: "marble-current", algorithm: "marble" },
  "Mottle Drift": { id: "mottle-drift", algorithm: "mottle" },
  "Iridescent Bloom": { id: "iridescent-bloom", algorithm: "iridescent-bloom" },
};
